import {CommonModule} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {RouterLink, RouterLinkActive, RouterOutlet} from '@angular/router';
import {AuthService} from '../../services/auth.service';
import {VisionConfigService} from '../../services/vte/vision-config.service';
import {customerVisionModeLabel} from '../../services/vte/vision-customer-labels';

type VisionConfigNavItem = {
    path: string;
    label: string;
    exact: boolean;
    superUserOnly?: boolean;
};

@Component({
    selector: 'app-vision-config-shell',
    standalone: true,
    imports: [CommonModule, RouterOutlet, RouterLink, RouterLinkActive],
    templateUrl: './vision-config-shell.component.html',
    styleUrl: './vision-config-shell.component.css',
})
export class VisionConfigShellComponent implements OnInit {
    private readonly baseNavItems: VisionConfigNavItem[] = [
        {path: '/vision-configuration/organization', label: 'Organization Vision', exact: false},
        {path: '/vision-configuration/cameras', label: 'Camera Analytics', exact: false},
        {path: '/vision-configuration/analytics-definitions', label: 'Capabilities', exact: false},
        {
            path: '/vision-configuration/provider-management',
            label: 'Vision Provider Management',
            exact: false,
            superUserOnly: true,
        },
    ];

    constructor(
        public visionConfig: VisionConfigService,
        private auth: AuthService,
    ) {
    }

    ngOnInit(): void {
        this.visionConfig.loadForCurrentOrganization().subscribe();
    }

    get navItems(): VisionConfigNavItem[] {
        if (this.auth.isSuperUser()) {
            return this.baseNavItems;
        }
        return this.baseNavItems.filter((item) => !item.superUserOnly);
    }

    get showImplementationDetails(): boolean {
        return this.auth.isSuperUser();
    }

    visionModeLabel(mode: string): string {
        return customerVisionModeLabel(mode);
    }
}
